

    // import * as S from '@/catalog-app/symbols';
    import { defineComponent, ref, provide, computed, watch, onMounted, WatchStopHandle, onUnmounted, reactive } from 'vue';
    import { useRouter, useRoute } from 'vue-router';
    import { useStore } from '@/catalog-app/store';

    // import { Carousel } from 'bootstrap';
    // import { useToast } from "primevue/usetoast";
    import Sidebar from '@/catalog-app/components/Sidebar.vue';
    import CardEq from '@/catalog-app/components/CardEq.vue';
    import CardPromo from '@/catalog-app/components/CardPromo.vue';
    import qs from 'qs';
    import { search } from '@/wesgroup/js/search';

    export default defineComponent({

        name: 'Catalog',

        components: { Sidebar, CardEq, CardPromo },

        props: {

        },

        // context.attrs
        // context.slots
        // context.emit
        setup(props, context) {

            // --- Data declarations ---
            const store = useStore();
            const router = useRouter();
            const route = useRoute();
            const state = store.state;
            const loading = ref(true);
            const searchQuery = ref('');
            const searchResults = reactive({
                results: {} as any,
            });
            let promoCarousel: any;

            // --- Vue computed getters ---

            /** Build a category path from vue-router params */
            const getCategoryPath = computed(() => {
                let categoryPath;
                if (route.params.category) {
                    const path = route.params.category as string[];
                    categoryPath = path.join('/');
                }
                return categoryPath;
            });

            // --- Vue methods ---

            /** Fetch cards from the server */
            const fetchCards = () => {
                // set loading to true
                loading.value = true;

                // build dict of params for API call
                const query = {
                    category: getCategoryPath.value || undefined,
                    brand: state.brand ? state.brand.id : undefined,
                    page: state.page > 1 ? state.page : undefined,
                    ...store.getSelections.value,
                };

                const queryParams = qs.stringify(query, { arrayFormat: 'repeat', indices: false });
                const url = `${state.endpoints.equipment}?${queryParams}`;

                fetch(url).then(response => {
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    return response.json();
                }).then(data => {

                    // HACK: remove selected from response so it doesn't interfere with query
                    if ('selected' in data) {
                        delete data['selected'];
                    }
                    // update state with data from server
                    store.update(data);

                    // emit "update-banner" event to App component
                    context.emit('updateBanner', {
                        title: data.title,
                        description: data.description,
                        img: data.img,
                        imgB: data.img_b,
                    });

                }).catch(e => {
                    // Error! Log to console for now.
                    console.log(e);
                }).finally(() => {
                    loading.value = false;
                });
            }

            /** Push selections and page (optionally) to the browser history. */
            const pushHistory = () => {
                // determine what the current query string should be
                const query = store.getSelections.value;
                // add page if needed
                if (state.page > 1) {
                    query['page'] = state.page;
                }
                // NOTE: route.query is watched by the Catalog component,
                // so this should trigger the fetchCards function
                router.push({ query });
                fetchCards();
            }

            /** Loads the next page */
            const loadNextPage = () => {
                if (state.page < state.pages) {
                    state.page++;
                    pushHistory();
                }
            }

            const query = route.query;
            if (query.page) {
                delete query.page
            }
            // set selections from the router
            store.setSelection(query);

            // --- Vue watch hooks ---

            // change browser query string when selections change
            let stopWatchHandle: WatchStopHandle;
            const stopWatch = () => {
                // console.log('No longer watching state.selected...');
                stopWatchHandle();
            }
            const startWatch = () => {
                // console.log('Now watching state.selected...');
                stopWatchHandle = watch(() => state.selected, pushHistory, { deep: true })
            }

            // fetch cards when we change query string
            // watch(() => route.query, fetchCards);
            watch(() => route.path, () => { // before, after
                stopWatch();
                // console.log('PATH BEFORE ', before);
                // console.log('PATH AFTER ', after);
                store.clearSelection();
                startWatch();
                fetchCards();

                if (promoCarousel) {
                    promoCarousel.dispose();
                    promoCarousel = null;
                }
                const promoCarouselEl = document.getElementById('promo-slider');
                if (promoCarouselEl) {
                    promoCarousel = new (window as any).Carousel(promoCarouselEl, {
                        interval: false,
                    });
                    console.log(promoCarouselEl);
                }
            });

            watch(searchQuery, async (before, after) => {

                if (state && state.catalog) {
                    if (searchQuery.value) {
                        const data = await search(searchQuery.value, state.catalog.id, 5);
                        searchResults.results = data.results;
                    } else {
                        searchResults.results = {};
                    }
                }
                // console.log(searchResults);
            });

            // --- Vue provide/inject hooks ---

            // provide loading to all children
            provide('loading', loading);

            // --- Vue lifecycle hooks ---
            onMounted(() => {
                // don't set route selections in onMounted so we don't trigger an API fetch
                startWatch();
                loading.value = false;
            });

            // onUnmounted(() => {
            //     console.log('Unmounted...')
            // });

            return {
                state,
                loading,
                searchQuery,
                searchResults,
                loadNextPage,
                // doSearch,
            }
        },

    });

